import { getDomainUrl } from 'core/utils';

export const customerQuoteListPath = () => '/quote/customer/list';
export const vendorQuoteListPath = () => '/quote/vendor/list';

export const quotePartsPath = (quoteId: number | string = ':quoteId', trigger = '') =>
  `/quote/${quoteId}/parts${trigger ? `?trigger=${trigger}` : ''}`;

export const oldCustomerQuotesPath = () => `${getDomainUrl()}/quote/customer`;

export const oldVendorQuotesPath = () => `${getDomainUrl()}/quote/vendor`;

export const oldQuotePartListPath = (quoteId: number | string = ':quoteId', trigger = '') =>
  `${getDomainUrl()}/quote/part/list?quote=${quoteId}${trigger ? `&trigger=${trigger}` : ''}`;
